import _ from "lodash";

export default [
    {
        "id": "YTD",
        "label": "Year-To-Date",
        "fixed": true,
        "getStartDate": () => new Date(new Date().getFullYear(), 0, 1),
        "getEndDate": () => new Date(),
        "default": true
    }, 
    {
        "id": "current-year",
        "label": "This Year",
        "fixed": true,
        "getStartDate": () => new Date(new Date().getFullYear(), 0, 1),
        "getEndDate": () => new Date(new Date().getFullYear() + 1, 0, 1)
    }, 
    {
        "id": "1-Year",
        "label": "Last Calendar Year",
        "fixed": true,
        "getStartDate": () => new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
        "getEndDate": () => new Date()
    }, 
    {
        "id": "last-quarter",
        "label": "This Quarter",
        "fixed": true,
        "getStartDate": () => {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth();
            const startQuarterMonth = currentMonth - (currentMonth % 3)
            
            return new Date(currentDate.getFullYear(), startQuarterMonth, 1)
        },
        "getEndDate": () => {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth();
            const startQuarterMonth = currentMonth - (currentMonth % 3)
            const isNextYear = startQuarterMonth + 3 > 11;
            const month = isNextYear? (startQuarterMonth + 3 - 12) : (startQuarterMonth + 3); 
            const year = isNextYear? currentDate.getFullYear() + 1 : currentDate.getFullYear();
            return new Date(year, month, 1)
        },
    },
    {
        "id": "one-year-projection",
        "label": "1-Year Projection (" + (new Date().getFullYear() + 1) +")",
        "fixed": true,
        "getStartDate": () => new Date(),
        "getEndDate": () => new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    },
    {
        "id": "three-year-projection",
        "label": "3-Year Projection (" + (new Date().getFullYear() + 3) +")",
        "fixed": true,
        "getStartDate": () => new Date(),
        "getEndDate": () => new Date(new Date().setFullYear(new Date().getFullYear() + 3))
    },
    {
        "id": "five-year-projection",
        "label": "5-Year Projection (" + (new Date().getFullYear() + 5) +")",
        "fixed": true,
        "getStartDate": () => new Date(),
        "getEndDate": () => new Date(new Date().setFullYear(new Date().getFullYear() + 5))
    },
    {
        "id": "ten-year-projection",
        "label": "10-Year Projection (" + (new Date().getFullYear() + 10) +")",
        "fixed": true,
        "getStartDate": () => new Date(),
        "getEndDate": () => new Date(new Date().setFullYear(new Date().getFullYear() + 10))
    },
    {
        "id": "custom",
        "label": "Custom",
        "fixed": false,
        "getStartDate": ({filterStartDate}) => filterStartDate,
        "getEndDate": ({filterEndDate}) => filterEndDate,
    }, 
    {
        "id": "all-time",
        "label": "All time",
        "fixed": true,
        "getStartDate": () => undefined,
        "getEndDate": () => undefined
    }
]

export const sortGraphDates  = (graph) => {
    const sortedGraph = graph;
    const comparator = (a, b) => {
        return (a.x ? Date.parse(a.x) : 0) - (b.x ? Date.parse(b.x) : 0);
    }
    (sortedGraph || []).forEach(element => {
        (element.graphData || []).forEach(aGraphData => {
            aGraphData.data?.sort(comparator);
        });
    });
    return sortedGraph;
}

export const minMaxGraphValue = (graph, {filterStartDate, filterEndDate}) => {
    let min = undefined;
    let max = undefined;
    
    (graph || []).forEach(element => {
        for (let i = 0; i < (element.data || []).length; i++) { 
            const {y: value, x: dateStr} = (element.data || [])[i];
            const {x: nextDateStr} = i + 1<(element.data || []).length ? (element.data || [])[i + 1] : {x: undefined};
            const {x: previousDateStr} = i !== 0 ? (element.data || [])[i - 1] : {x: undefined};

            const valueWithinLeftRange = value !== undefined && value !== null && dateStr && 
                            (!filterStartDate || Date.parse(dateStr) >= filterStartDate || (nextDateStr && Date.parse(nextDateStr) > filterStartDate));
            const valueWithinRightRange = value !== undefined && value !== null && dateStr && 
                            (!filterEndDate || Date.parse(dateStr) <= filterEndDate || (previousDateStr && Date.parse(previousDateStr) < filterEndDate));

            if(valueWithinLeftRange && valueWithinRightRange) {
                min = (min === undefined ? value : Math.min(value, min));
                max = (max === undefined ? value : Math.max(value, max));
            }
        }
    });
    
    //apply a coefficient for better visualization
    if(min === undefined || max === undefined) {
        min = "auto";
        max = "auto";
    } else {
        min -= (max - min) * 0.05;
        max += (max - min) * 0.05;
    }
    return {min, max};
}